module.exports = __webpack_public_path__ + "ebf1dc0edf35a7077f7d8f1cc5965803.svg";